function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Redirect from 'shared/components/Redirect';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import { defaultValues as addressState } from 'researcher/payment/components/AddressForm';
import AddressForm from 'researcher/payment/components/AddressFormContainer';
import { convertFormDataToJson } from 'shared/view/address-conversion-service';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
var Form = Controls.Form;
var defaultValues = {
  userAddress: addressState
};
var SavedAddressForm = function SavedAddressForm(_ref) {
  var address = _ref.address,
    invoiceAddress = _ref.invoiceAddress,
    updateAddress = _ref.updateAddress;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    busy = _useState4[0],
    setBusy = _useState4[1];
  var handleUpdateAddress = function handleUpdateAddress(address) {
    setBusy(true);
    updateAddress(address).then(function () {
      setBusy(false);
      setRedirect('/account/addresses');
    });
  };
  if (redirect) {
    return /*#__PURE__*/React.createElement(Redirect, {
      push: true,
      to: redirect
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "saved-address-form new-button-styles"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(T, {
    source: "Edit address"
  })), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    model: "form.accountSavedAddress",
    onSubmit: preprocessData(convertFormDataToJson, handleUpdateAddress)
  }, /*#__PURE__*/React.createElement(AddressForm, {
    address: address,
    displayHeader: false,
    enableAddressSelection: false,
    name: "userAddress",
    nameField: invoiceAddress ? '' : 'Customer name',
    organizationField: true,
    organizationFieldLabel: invoiceAddress ? 'invoice-payer-name' : 'Organization name',
    organizationFieldRequired: invoiceAddress,
    phoneField: address.phone,
    type: "user",
    vatField: false,
    Controls: Controls,
    validators: validators
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: busy,
    className: "btn btn-primary btn-squared me-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Save changes"
  })), !busy ? /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-squared",
    to: "/account/addresses"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Cancel"
  })) : null, busy ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null)));
};
export default SavedAddressForm;